import { BaseMutations } from '@/store/base-mutations';
import { PaginationProps, TableOptions } from '@/types';
import { default_invite } from '../services';
import { InviteUserData, Staffs, StaffsFilters } from '../types';
import StaffState from './state';

export default class StaffMutations extends BaseMutations<StaffState> {
  SET_STAFFS(staffs: Staffs.Staff[]) {
    this.state.staffs = staffs;
  }

  SET_CURRENT_STAFF(staff: Staffs.Staff) {
    this.state.current_staff = staff;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof StaffsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  SET_CITIES(cities: string[]) {
    this.state.cities = cities;
  }

  UPD_NEW_INVITE_STAFF({ key, value }: { key: keyof InviteUserData, value: InviteUserData[keyof InviteUserData] }) {
    this.state.new_staff_invite[key] = value;
  }

  RESET_NEW_INVITE_STAFF() {
    this.state.new_staff_invite = default_invite();
  }

  TOGGLE_LOADING_STAFFS(toggle: boolean) {
    this.state.staff_loading = toggle;
  }

  SET_STAFF_FOR_TRANSFER(staff: Staffs.Staff) {
    if (staff.id) {
      this.state.changing_info.staff_id = staff.id;
    }

    if (staff) {
      this.state.staff_for_role_changing = staff;
    }
  }

  UPD_TRANSFER_CODE(code: number | null) {
    this.state.changing_info.code = code;
  }

  CLEAR_TRANSFER_INFO_ANG_STAFF() {
    this.state.changing_info = {
      staff_id: 0,
      code: null,
    };
    this.state.staff_for_role_changing = {} as Staffs.Staff;
  }

  CLEAR_ERROR_MESSAGE() {
    this.state.transfer_role_error_message = '';
  }

  CLEAR_TRANSFER_CODE() {
    this.state.changing_info.code = null;
  }

  TOGGLE_ALL_STAFFS(value: boolean) {
    this.state.all_staffs = value;
  }

  CLEAR_ALL_STAFFS() {
    this.state.all_staffs = false;
  }

  CLEAR_ALL_FILTERS() {
    this.state.filters = {
      search: '',
      role: [],
      status: null,
      city: '',
    };
  }
}
